export interface Input {
    ext: string;
    mps: number;
    mime: string;
    format: string;
    width: number;
    height: number;
}
export interface Output {
    ext: string;
    mps: number;
    mime: string;
    format: string;
    width: number;
    height: number;
    tmp_url: string;
    object_key: string;
    object_bucket: string;
    object_uri: string;
    claid_storage_uri: string;
}

export interface Data {
    input: Input;
    output: Output;
}
export interface UpscaleResponse {
    data: Data;
}


export interface FailureResponse {
    error_code: string
    error_type: string;
    error_message: string
}

export class ClaidApiFailure extends Error {

    private errorCode: string;
    private errorType: string;
    private errorMessage: string;
    private customMessage: string = "The request for AI upscaling failed. The original image(s) can still be uploaded.";

    constructor(failure: FailureResponse) {
        super(failure.error_message);
        this.errorCode = failure.error_code;
        this.errorType = failure.error_type;
        this.errorMessage = failure.error_message;

        console.error(
            '%cClaid Service Failure',
            'display: inline-block; color: #fff; background: red; padding: 1px 4px; border-radius: 3px;',
            {
                ErrorCode: this.errorCode,
                ErrorType: this.errorType,
                ErrorMessage: this.errorMessage
            }
        );
    }
    get ErrorCode(): string {
        return this.errorCode;
    }
    get ErrorType(): string {
        return this.errorType;
    }
    get ErrorMessage(): string {
        return this.errorMessage;
    }
    get CustomMessage(): string {
        return this.customMessage;
    }
}


export  class UploadService {


    public static async upscale(file: File, operations: any): Promise<UpscaleResponse> {


        let headers: Headers = new Headers();
        headers.append("Host", "api.claid.ai");
        headers.append("Authorization", "Bearer f720392f1d0747d2bfc583b4ce3ec519");

        let formdata: FormData = new FormData();
        formdata.append("file", file, file.name);
        formdata.append("data", JSON.stringify(operations));

        let requestOptions = {
            method: 'POST',
            headers: headers,
            body: formdata,
            redirect: 'follow'
        };

        // @ts-ignore
        const response: Response = await fetch('https://api.claid.ai/v1-beta1/image/edit/upload', requestOptions);
        const data = await response.json();

        if (data.error_code) {

            throw new ClaidApiFailure(data);
        }

        return data;
    }

}


// WEBPACK FOOTER //
// ./vendor/valnet/valnet_imagePicker/js/claidai/service.ts